import { Form, Input, ModalProps, FormProps, Modal, InputNumber, Select, useSelect } from '@pankod/refine-antd'
import { useGetIdentity } from '@pankod/refine-core'
import { IGrade, IReportTheme, ISubject } from 'interfaces'
import { useEffect } from 'react'

type EditTestTrackProps = {
  modalProps: ModalProps
  formProps: FormProps
}

export const EditTestTrack: React.FC<EditTestTrackProps> = ({ modalProps, formProps }) => {
  useEffect(() => {
    formProps.form?.resetFields()
  }, [])
  const { data: user } = useGetIdentity()
  const { selectProps: gradeSelectProps } = useSelect<IGrade>({
    resource: 'grades',
    optionLabel: 'name',
    optionValue: 'id',
    metaData: {
      fields: ['id', 'name'],
    },
    fetchSize: 1000,
    sort: [{ field: 'name', order: 'asc' }],
    onSearch: value => [
      {
        field: 'name',
        operator: 'contains',
        value: `${value.toLowerCase()}%`,
      },
    ],
  })
  const { selectProps: subjectSelectProps } = useSelect<ISubject>({
    resource: 'subjects',
    optionLabel: 'name',
    optionValue: 'id',
    metaData: {
      fields: ['id', 'name'],
    },
    fetchSize: 1000,
    sort: [{ field: 'name', order: 'asc' }],
    filters: [
      {
        field: 'in_use',
        operator: 'eq',
        value: true,
      },
    ],
    onSearch: value => [
      {
        field: 'name',
        operator: 'contains',
        value: `${value.toLowerCase()}%`,
      },
    ],
  })

  const { selectProps: reportThemeSelectProps } = useSelect<IReportTheme>({
    resource: 'report_themes',
    fetchSize: 100,
    optionLabel: 'name',
    optionValue: 'id',
    metaData: {
      fields: ['id', 'name'],
    },
    sort: [{ field: 'name', order: 'asc' }],
    onSearch: value => [
      {
        field: 'name',
        operator: 'contains',
        value: `${value.toLowerCase()}%`,
      },
    ],
  })

  return (
    <Modal {...modalProps} title="Edit Test Track">
      <Form {...formProps} layout="vertical">
        <Form.Item
          label="Test Track Name"
          name="name"
          rules={[
            {
              required: true,
            },
          ]}
        >
          <Input />
        </Form.Item>
        <Form.Item label="Grade" name="grade_ids" rules={[{ required: true }]}>
          <Select {...gradeSelectProps} mode="multiple" />
        </Form.Item>
        <Form.Item label="Subject" name="subject_ids" rules={[{ required: true }]}>
          <Select {...subjectSelectProps} mode="multiple" />
        </Form.Item>
        {/* report theme */}
        <Form.Item label="Report Theme" name="report_theme_ids" rules={[{ required: true, message: 'please select atleast one report theme' }]}>
          <Select {...reportThemeSelectProps} mode="multiple" />
        </Form.Item>
        <Form.Item name="updated_by" initialValue={user?.id}>
          <Input type="hidden" />
        </Form.Item>
      </Form>
    </Modal>
  )
}
